import { connect } from 'react-redux';
import { getPopupActReport } from '../../../store/actions/popupAct';
import HolderReportCell from './HolderReportCell';

const mapStateToProps = ({
  popupActReducer
}) => ({
  popupActReducer
});
const mapDispatchToProps = { getPopupActReport };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HolderReportCell);
